"use client";

import * as React from "react";
import styled, { css } from "styled-components";
import defaultTheme from "../defaultTheme";
import { borderRadius, rtlSpacing } from "../utils/rtl";
import mq from "../utils/mediaQuery";
const StyledButtonGroup = styled.div.withConfig({
  displayName: "ButtonGroup__StyledButtonGroup",
  componentId: "sc-t9p5ql-0"
})(["display:flex;.orbit-button-primitive{border-radius:0;margin:", ";:first-child{border-radius:", ";}:last-child{border-radius:", ";margin:0;}}", ";"], ({
  theme
}) => rtlSpacing(theme.orbit.marginButtonGroup), borderRadius("6px 0 0 6px"), borderRadius("0 6px 6px 0"), mq.tablet(css([".orbit-button-primitive{:first-child{border-radius:", ";}:last-child{border-radius:", ";}}"], ({
  theme
}) => borderRadius(`${theme.orbit.borderRadiusNormal} 0 0 ${theme.orbit.borderRadiusNormal}`), ({
  theme
}) => borderRadius(`0 ${theme.orbit.borderRadiusNormal} ${theme.orbit.borderRadiusNormal} 0`))));
StyledButtonGroup.defaultProps = {
  theme: defaultTheme
};
const ButtonGroup = ({
  children,
  dataTest
}) => /*#__PURE__*/React.createElement(StyledButtonGroup, {
  "data-test": dataTest
}, children);
export default ButtonGroup;